import $ from "jquery"

function enableSlickKeyboardNavigation($slider) {
    if (!$slider || $slider.length === 0) return;
    var keyListenerAdded = false;

    function handleArrowKeys(event) {
        if (event.key === 'ArrowLeft') {
        event.preventDefault();
        $slider.slick('slickPrev');
        } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        $slider.slick('slickNext');
        }
    }

    function checkVisibility() {
        var top_of_element = $slider.offset().top;
        var bottom_of_element = top_of_element + $slider.outerHeight();
        var top_of_screen = $(window).scrollTop();
        var bottom_of_screen = top_of_screen + $(window).height();

        var isVisible = (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);

        if (isVisible && !keyListenerAdded) {
        $(window).on('keydown.slickNav', handleArrowKeys);
        keyListenerAdded = true;
        } else if (!isVisible && keyListenerAdded) {
        $(window).off('keydown.slickNav', handleArrowKeys);
        keyListenerAdded = false;
        }
    }

    $(window).on('scroll resize', checkVisibility);
    checkVisibility();
}


$(function() {
    enableSlickKeyboardNavigation($('.js-slider-hero'));
    enableSlickKeyboardNavigation($('.js-slider-testimonials-new'));
    enableSlickKeyboardNavigation($('.js-slider-default'));
    enableSlickKeyboardNavigation($('.js-hero-footer-slick'));
    enableSlickKeyboardNavigation($('.outsourcing-slider__text'));
    enableSlickKeyboardNavigation($('.business-flow__nav-slider'));
    enableSlickKeyboardNavigation($('.js-story-slider'));
    enableSlickKeyboardNavigation($('.js-content-slider'));
    enableSlickKeyboardNavigation($('.js-brands-slider'));
    enableSlickKeyboardNavigation($('.solutions__slider'));
    enableSlickKeyboardNavigation($('.people__slider'));
    // Add more sliders as needed
});
